// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.register-reward-container {
  height: calc(96 * var(--width-ratio));
  background: transparent;
  position: relative;
}
.register-reward-container .x-button {
  position: absolute;
  top: 0;
  right: calc(10 * var(--width-ratio));
  color: var(--ion-color-light-tint);
}
.register-reward-container .register-reward-content-div {
  background: var(--ion-color-primary-shade);
  height: calc(82 * var(--width-ratio));
  border-radius: 20px;
}
.register-reward-container .mybutton {
  width: calc(96 * var(--width-ratio));
  height: calc(34 * var(--width-ratio));
  margin: auto;
  --border-radius: 40px;
  --border-color: white;
  color: white;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/register-reward-toast/register-reward-toast.component.scss"],"names":[],"mappings":"AAAA;EACE,qCAAA;EACA,uBAAA;EACA,kBAAA;AACF;AACE;EACE,kBAAA;EACA,MAAA;EACA,oCAAA;EACA,kCAAA;AACJ;AAEE;EACE,0CAAA;EACA,qCAAA;EACA,mBAAA;AAAJ;AAGE;EACE,oCAAA;EACA,qCAAA;EACA,YAAA;EACA,qBAAA;EACA,qBAAA;EACA,YAAA;AADJ","sourcesContent":[".register-reward-container {\n  height: calc(96 * var(--width-ratio));\n  background: transparent;\n  position: relative;\n\n  .x-button {\n    position: absolute;\n    top: 0;\n    right: calc(10 * var(--width-ratio));\n    color: var(--ion-color-light-tint);\n  }\n\n  .register-reward-content-div {\n    background: var(--ion-color-primary-shade);\n    height: calc(82 * var(--width-ratio));\n    border-radius: 20px;\n  }\n\n  .mybutton {\n    width: calc(96 * var(--width-ratio));\n    height: calc(34 * var(--width-ratio));\n    margin: auto;\n    --border-radius: 40px;\n    --border-color: white;\n    color: white;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
